export default "__VITE_ASSET__bfeccbe7__"